import { render } from "./indexiosPrivacyPolicy.vue?vue&type=template&id=c3fa2994&scoped=true&ts=true"
import script from "./indexiosPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./indexiosPrivacyPolicy.vue?vue&type=script&lang=ts"

import "./indexiosPrivacyPolicy.vue?vue&type=style&index=0&id=c3fa2994&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fa2994"]])

export default __exports__